/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Clear_Vole_SpinInputs */

const en_free_clear_vole_spin = /** @type {(inputs: Free_Clear_Vole_SpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting...`)
};

const de_free_clear_vole_spin = /** @type {(inputs: Free_Clear_Vole_SpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lösche...`)
};

/**
* | output |
* | --- |
* | "Deleting..." |
*
* @param {Free_Clear_Vole_SpinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const free_clear_vole_spin = /** @type {((inputs?: Free_Clear_Vole_SpinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Clear_Vole_SpinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_free_clear_vole_spin(inputs)
	return de_free_clear_vole_spin(inputs)
});